export const CSRF_TOKEN_HEADER = "X-Csrf-Token"
export const AUTHORIZATION_HEADER = "Authorization"
export const CLIENT_INFO_HEADER = "X-Client-Info"
